export default class NewsCategory {
    public id: string;
    public title: string;
    public friendlyUrl: string;
    public contentTypeId: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.friendlyUrl = "";
      this.contentTypeId = "newsCategory";
    }
  }


// WEBPACK FOOTER //
// ./src/api/newsCategoryEntity.ts